import { forwardRef, JSX } from 'react';

import { CloseIcon } from '~components/icons/CloseIcon';
import { Button } from '~modules/media-library/view/Button';
import { EditAssetsWizard } from '~modules/media-library/view/Contribute/EditAssetsWizard/EditAssetsWizard';

type EditAssetsModalPanelProps = {
  onClose?: () => void;
  isOpen: boolean;
};

export const EditAssetsModalPanel = forwardRef<
  HTMLDivElement,
  JSX.IntrinsicElements['div'] & EditAssetsModalPanelProps
>(function EditAssetsModal({ onClose, className, ...TheirProps }, ref) {
  return (
    <div
      className={`ml--detail-modal--panel bg-white   rounded-md shadow-xl w-full max-w-2xl max-h-lg min-h-0  flex flex-col relative ${
        className ? className : ''
      }`}
      {...TheirProps}
      ref={ref}
    >
      <Button variant="icon" className="absolute top-0 right-0 border-none" onClick={onClose}>
        <CloseIcon />
      </Button>
      <EditAssetsWizard onClose={onClose} />
    </div>
  );
});
